export default "__VITE_ASSET__CjMyg9Ig__"